import React from 'react';
import Select from 'react-select';
import { SHOW_CANDIDATE_MODE } from "@app/constants/Common";

const HideShowStatusCard = ({
    hideShow,
    userSearchOptions,
    onChangeInputHideShowConditions,
    userLoginInfo
}) => {
    if (!userLoginInfo || !userLoginInfo.is_superuser) {
        return null;
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Trạng thái hide/show</h3>
                <input type="checkbox" 
                       name={`has_check_hide_show`} 
                       className={"ml-2"}
                       defaultChecked={!!hideShow.has_check_hide_show}
                       style={{height: 20, width: 20, verticalAlign: 'middle'}}
                       onChange={event => onChangeInputHideShowConditions(event.target.value, 'has_check_hide_show')}
                />
            </div>
            {hideShow.has_check_hide_show && (
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='input-group'>
                                <div className='input-group'>
                                    <label>Chọn users</label>
                                    {/*<input type="checkbox"*/}
                                    {/*       className="ml-3" name={'only_user_input'}*/}
                                    {/*       style={{width: 20, height: 20}}*/}
                                    {/*       value={hideShow.is_select_all_users}*/}
                                    {/*       checked={hideShow.is_select_all_users}*/}
                                    {/*       onChange={(event) => onChangeInputHideShowConditions(event.target.value, 'is_select_all_users')}/>*/}
                                </div>
                                <div style={{width: '100%'}}>
                                    <Select options={userSearchOptions}
                                            isMulti
                                            placeholder={"Tất cả users"}
                                            // isDisabled={hideShow.is_select_all_users}
                                            value={hideShow.select_users}
                                            onChange={values => {
                                                onChangeInputHideShowConditions(values, "select_users");
                                            }}
                                    />
                                </div>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Hide/Show</b></label>
                                <select className='form-control'
                                        name={'show_hide_state'}
                                        value={hideShow.show_hide_state}
                                        onChange={event => onChangeInputHideShowConditions(event.target.value, "show_hide_state")}>
                                    {SHOW_CANDIDATE_MODE.map(item => {
                                        return <option key={item.value} value={item.value}>{item.label}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HideShowStatusCard;
